<template>
  <a-row type="flex" justify="center" style="margin:15px">
    <a-col :span="24" :sm="24" :md="24" :lg="20" :xl="16" class="bg-primary">
      <a-layout class="layout">
        <div>
          <router-view name="head" :membersList="membersList" :societyList="societyList"></router-view>
        </div>
        <div>
          <router-view name="content"></router-view>
        </div>
        <div style="text-align: center">
          <router-view name="foot"></router-view>
        </div>
      </a-layout>

    </a-col>
  </a-row>

</template>

<script>
import {getMemberList, getSocietyList} from "../../api/api";

export default {
  name: "layout",
  data() {
    return {
      membersList: [],
      societyList: [],


    }
  },
  mounted() {
    getMemberList().then(res => {
      let member = res.data
      let arr = []
      member.forEach(item => {
        let newItem = {}
        newItem['id'] = item.id
        newItem['name'] = item.name
        arr.push(newItem)
      })
      this.membersList = arr
    }).catch((err) => {
      console.log(err)
    })

    getSocietyList().then(res => {
      let society = res.data
      let arr = []
      for (let i = 0; i < society.length; i++) {
        let newItem = {}
        newItem['id'] = society[i].id
        newItem['name'] = society[i].name
        arr.push(newItem)
      }
      this.societyList = arr

    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>

<style scoped="less">
.header {
  background-color: #6699CC;
  height: 48px;
}

</style>



// WEBPACK FOOTER //
// src/components/layout/layout.vue